import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AccountPayableReportService {
  private url = environment.api;

  constructor(
    private http: HttpClient,
  ) { }

  getBillPayableGeneralBalanceReport(date: number, type: string, warehouseId = 0) {
    return this.http.get(this.url + "api/erp/bill/reports/pay1/" + type, {
      params: {
        date: date,
        warehouseId: warehouseId
      }
    });
  }

  
  getBillPayableList(type: string) {
    return this.http.get(this.url + "api/erp/bill/reports/list/" + type, {
      params: {
        cxp: true
      }
    });
  }
}
